/*
# -----------------------------------------------------------------------------
# Component: packageDataMixin.js
# Author: ssy@pst.sg
# Created Date: 03/March/2020
# Comments: Responsible for shared components - Package Parameters
# -----------------------------------------------------------------------------
*/

import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'
import MessageMixin from '@/mixins/message'

export const packageDataMixin = {
  data() {
    return {
      sideFunction: [
        // {
        //   text: 'Campaign',
        //   icon: 'mdi-launch',
        //   iconColor: 'primary',
        //   params: { name: '' }
        // },
        {
          text: 'Package Plan',
          icon: 'mdi-launch',
          iconColor: 'primary',
          params: { name: 'pkgPlan' }
        },
        {
          text: 'Package Tariff Benefit',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'pckgTariffBen' }
        },
        {
          text: 'Package Tariff Factor',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'pckgTariffFact' }
        },
        {
          text: 'Package Tariff Rate',
          icon: 'mdi-launch',
          iconColor: 'primary',
          params: { name: '' }
        },
        // {
        //   text: 'Scheme',
        //   icon: 'mdi-tune',
        //   iconColor: 'primary',
        //   params: { name: 'scheme' }
        // },
        {
          text: 'Permit Policy Type',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'polTypeScheme' }
        },
        {
          text: 'Package Standard Risk Text',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'pkgStdRiskTxt' }
        }
      ]
    }
  },
  // methods: {
  // doInit(pKey) {
  //   const apiURI = this.menu.packageParamList
  //   if (apiURI) {
  //     const params = {
  //       paramKey: pKey,
  //       paramString: ''
  //     }
  //     this.loading = true
  //     this.$http.get(expandURI(apiURI, params)).then(result => {
  //       this.items = []
  //       const { data } = result.data
  //       if (data) {
  //         data.map(result => {
  //           const convertList = {
  //             paramName: result.paramName,
  //             paramType: result.paramType,
  //             paramDesc: result.paramDesc
  //           }
  //           this.items.push(convertList)
  //         })
  //       }
  //       this.loading = false
  //     }).catch(err => {
  //       this.loading = false
  //       const { data } = err.response
  //       if (data) {
  //         this.message(data)
  //         this.fieldMessage(data)
  //       }
  //     })
  //   }
  // }
  // },
  components: {
    SideFunctionMenu
  },
  // computed: {
  //   menu() {
  //     return this.$store.state.pkgParam.menu
  //   }
  // },
  mixins: [
    MessageMixin
  ]
}
